<template>
  <div>
    <div class="mb-2">
      {{ msg }}
    </div>

    <b-overlay :show="busy">
      <div class="div-section-body">

        <b-form @submit.stop.prevent="submit">
          <b-row>
            <b-col cols="12">
              <div class="px-2">
                <!-- New password -->
                <b-form-group
                  label="New Password"
                  label-for="password"
                  label-size="sm"
                  class="mb-2"
                  label-class="mb-0 pt-2 font-weight-bold"
                >
                  <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="lock"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input
                      id="password"
                      v-model="$v.passwords.password.$model"
                      type="password"
                      placeholder="New password"
                      :state="validateState('password')"
                      aria-describedby="support-password-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback v-if="!$v.passwords.password.required">Password is required.</b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!$v.passwords.password.minLength">Password must be 6 characters or longer.</b-form-invalid-feedback>
                    <b-form-invalid-feedback v-if="!$v.passwords.password.regexPwd">Invalid character(s) detected.</b-form-invalid-feedback>
                    <!-- <b-form-invalid-feedback id="support-password-feedback">Password is required.</b-form-invalid-feedback> -->
                  </b-input-group>
                </b-form-group>

                <!-- New password retype -->
                <b-form-group
                  label="New Password (retype)"
                  label-for="password2"
                  label-size="sm"
                  class="mb-2"
                  label-class="mb-0 pt-2 font-weight-bold"
                >
                  <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="lock"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input
                      id="password2"
                      v-model="$v.passwords.password2.$model"
                      type="password"
                      placeholder="New password (retype)"
                      :state="validateState('password2')"
                      aria-describedby="support-password2-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="support-password2-feedback">Passwords must match.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>

                <transition name="fade" mode="out-in">
                  <div>
                    <b-alert
                      v-model="error"
                      key="error-box"
                      show
                      variant="danger"
                      dismissible
                      class="mt-2"
                    >{{errorMsg}}</b-alert>
                    <b-alert
                      v-model="success"
                      key="success-box"
                      show
                      variant="success"
                      dismissible
                      class="mt-2"
                    >Account password updated.</b-alert>
                  </div>
                </transition>

                <div class="text-center mt-2 mb-2">
                  <b-button type="submit" variant="info">Update Password</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-form>

      </div>
    </b-overlay>

    <b-card class="mt-5 mb-2">
      <div class="text-left">
        Click the link below if you reside in the European Economic Area (EEA) and choose to exercise the option to remove your access to your personally identifiable information contained in this site.
      </div>
      <div class="mt-2 text-center">
        <b-link class="text-center" to="/gdpr">GDPR Remove Consent</b-link>
      </div>
    </b-card>

  </div>
</template>

<script>
/* eslint-disable */

import service from "@/service/service";
import utils from "@/utils/utils";

import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength,
  between,
  sameAs,
  helpers
} from "vuelidate/lib/validators";

// Password regex: Allow alphanumeric and some special characters
const regexPwd = helpers.regex('regexPwd', /^[a-zA-Z0-9.!@#$%&*~:;?+=^_-]*$/)

export default {
  name: "AccountPassword",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: "System error - contact tech support.",
      loading: false,
      busy: false,
      success: false,
      passwords: {
        password: null,
        password2: null
      },
      msg: "Use form below to change your account password.",
      form: this.value
    };
  },
  props: {
    // student object. the v-model for the component
    value: {
      type: Object,
      default: {}
    }
  },
  mixins: [validationMixin],
  validations: {
    passwords: {
      password: {
        required,
        minLength: minLength(6),
        regexPwd
      },
      password2: {
        sameAsPassword: sameAs("password")
      }
    }
  },
  watch: {
    form: {
      deep: true,
      handler(vmodel) {
        // receives updated this.form
        // console.log('watcher')
        // console.log(vmodel)
        // Send updated model to parent.
        this.$emit("input", vmodel); // send to listeners as input event
      }
    }
  },
  computed: {},
  methods: {
    validateState(name) {
      // console.log(`name: ${name}`)
      const { $dirty, $error } = this.$v.passwords[name];
      return $dirty ? !$error : null;
    },
    submit(e) {
      this.$v.passwords.$touch();
      if (this.$v.passwords.$anyError) {
        console.log(`ERROR!!`);
        return;
      }
      this.error = false;
      this.success = false;
      this.busy = true;

      this.form.password = this.passwords.password;

      service
        .saveProfile(this.form)
        .then(res => {
          if (this.debug) console.log(res.data);
          if (res.status) {
            this.success = true;
          } else {
            this.success = false;
            this.errorMsg = data.errorMsg || "Service error.";
            this.error = true;
          }
        })
        .finally(() => {
          this.busy = false;
        })
        .catch(e => {
          console.log(e);
          this.error = true;
        });
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AccountPassword.vue